import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AccountingPeriod, AccountingPeriodCreate, AccountingPeriodFilter } from '../data/accountingPeriod';

export function createAccountingPeriodService(client: AxiosInstance) {
  return createCrudService<AccountingPeriod, AccountingPeriodCreate, AccountingPeriodFilter>(
    client,
    '/accounting/AccountingPeriod',
    'id',
  );
}

export type AccountingPeriodService = CrudService<AccountingPeriod, AccountingPeriodCreate, AccountingPeriodFilter>;
